const getRoundedPrice = price => Number(price.toFixed(2));

export default getRoundedPrice;
